<template>
	<div class="agency-application-name">
		<h1>Podgląd formularza wniosku{{ contestName ? ' ' + contestName : '' }}</h1>
		<v-layout row>
			<h1>Wniosek ({{ title }})</h1>
			<v-icon
				
				small
				@click="renameOpen = true"
			>edit
			</v-icon>
			<egranty-input-field-popup
				:is-open.sync="renameOpen"
				:default-value="title" 
				field-type="LONG_TEXT"
				long
				label="Nowy tytuł"
				for="agency-application-new-name"
				id="agency-application-new-name"
				title="Zmień tytuł wniosku"
				@save="rename"
			></egranty-input-field-popup>
		</v-layout>
		<br>
	</div>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "AgencyApplicationNameEmpty",
		components: {EgrantyInputFieldPopup},
		methods: {

			rename(val) {
				if (val === "" || val === undefined || val === null) {
					return;
				}
				this.title = val;
				this.renameOpen = false;
			},

		},

		data() {
			return {
				renameOpen: false,
				title: "Polski tytuł wniosku",
			};
		},

		props: {
			readonly: {
				type: Boolean,
				default: false,
			},
			contestName: {
				type: String,
				default: "",
			},
		},
	};
</script>

<style scoped>
	.agency-application-name {
		margin-left: 20px;
		margin-right: 20px;
	}
</style>